{
  "items": {
    "rusty_sword": "Paslı Kılıç",
    "iron_sword": "Demir Kılıç",
    "iron_hatchet": "Demir Balta",
    "worn_daggers": "Yıpranmış Hançerler",
    "iron_daggers": "Demir Hançerler",
    "ash_staff": "Dişbudak Asa",
    "oak_staff": "Meşe Asa",
    "wooden_mace": "Tahta Topuz",
    "iron_mace": "Demir Topuz",
    "wooden_shield": "Tahta Kalkan",
    "iron_shield": "Demir Kalkan",
    "leather_cap": "Deri Başlık",
    "padded_vest": "Kapitone Yelek",
    "leather_gloves": "Deri Eldiven",
    "leather_boots": "Deri Çizme",
    "iron_helm": "Demir Miğfer",
    "chain_vest": "Zincir Zırh",
    "iron_gauntlets": "Demir Eldiven",
    "iron_boots": "Demir Çizme",
    "copper_ring": "Bakır Yüzük",
    "bone_necklace": "Kemik Kolye",
    "minor_hp_potion": "Küçük Can İksiri",
    "minor_mp_potion": "Küçük Mana İksiri",
    "boar_hide": "Domuz Postu",
    "wolf_fang": "Kurt Dişi",
    "toad_slime": "Kurbağa Balçığı",
    "husk_stone": "Kabuk Taşı",
    "upgrade_scroll": "Yükseltme Kağıdı",
    "colony_scroll": "En İyi Yükseltme Kağıdı",
    "jewelry_scroll": "Takı Kağıdı",
    "fortune_stone": "Şans Taşı",
    "market_scroll": "Pazar Kağıdı",
    "steel_sword": "Çelik Kılıç",
    "steel_falchion": "Çelik Pala",
    "steel_daggers": "Çelik Hançerler",
    "steel_venom_daggers": "Zehirli Hançerler",
    "steel_staff": "Demirağaç Asa",
    "steel_mace": "Çelik Topuz",
    "steel_shield": "Çelik Kalkan",
    "steel_helm": "Çelik Miğfer",
    "steel_plate": "Çelik Göğüslük",
    "steel_gauntlets": "Çelik Eldiven",
    "steel_boots": "Çelik Çizme",
    "mithril_sword": "Mithril Kılıç",
    "mithril_waraxe": "Mithril Savaş Baltası",
    "mithril_daggers": "Mithril Hançerler",
    "mithril_rime_daggers": "Kırağı Hançerleri",
    "mithril_staff": "Mithril Asa",
    "mithril_mace": "Mithril Topuz",
    "mithril_shield": "Mithril Kalkan",
    "mithril_helm": "Mithril Miğfer",
    "mithril_plate": "Mithril Göğüslük",
    "mithril_gauntlets": "Mithril Eldiven",
    "mithril_boots": "Mithril Çizme",
    "dragon_sword": "Ejder Kılıcı",
    "dragon_wingblade": "Ejder Kanatkılıcı",
    "dragon_scythe": "Ejder Tırpanı",
    "dragon_daggers": "Ejder Hançerleri",
    "dragon_storm_daggers": "Fırtınadiş Hançerleri",
    "dragon_staff": "Ejderkemiği Asa",
    "dragon_mace": "Ejder Topuzu",
    "dragon_shield": "Ejder Kalkanı",
    "dragon_helm": "Ejder Miğferi",
    "dragon_plate": "Ejder Göğüslüğü",
    "dragon_gauntlets": "Ejder Eldiveni",
    "dragon_boots": "Ejder Çizmesi",
    "silver_ring": "Gümüş Yüzük",
    "moonstone_amulet": "Aytaşı Muska",
    "warlord_signet": "Savaş Beyi Mühürlü Yüzüğü",
    "bear_pelt": "Ayı Postu",
    "troll_tusk": "Trol Dişi",
    "ember_core": "Köz Çekirdeği",
    "leather_belt": "Deri Kemer",
    "garnet_stud": "Lal Küpe",
    "iron_girdle": "Demir Kuşak",
    "obsidian_hoop": "Obsidyen Halka Küpe",
    "emberbound_belt": "Köz Bağlı Kemer",
    "frostbound_belt": "Ayaz Bağlı Kemer",
    "stormbound_belt": "Fırtına Bağlı Kemer",
    "earring_of_the_vanguard": "Öncü Küpesi",
    "earring_of_the_shadow": "Gölge Küpesi",
    "earring_of_the_arcanist": "Arkanist Küpesi",
    "earring_of_the_devout": "Dindar Küpesi",
    "ashdrake_pendant": "Kül Ejderi Kolyesi",
    "frostdrake_pendant": "Ayaz Ejderi Kolyesi",
    "stormdrake_pendant": "Fırtına Ejderi Kolyesi",
    "bloodstone_ring": "Kantaşı Yüzük",
    "moonglass_ring": "Aycamı Yüzük",
    "heart_of_the_colossus": "Dev'in Kalbi",
    "cloak_of_the_vanguard": "Öncü Pelerini",
    "cloak_of_the_blooded": "Kanlıların Pelerini",
    "cloak_of_the_champion": "Şampiyon Pelerini",
    "cloak_of_the_paragon": "Kusursuzlar Pelerini",
    "azure_glow": "Mavi Işıltı",
    "solar_glow": "Güneş Işıltısı",
    "ember_glow": "Köz Işıltısı",
    "verdant_glow": "Yeşil Işıltı",
    "violet_glow": "Mor Işıltı",
    "prism_glow": "Prizma Işıltısı",
    "hellmaw_cleaver": "Hellmaw Satırı",
    "fangs_of_hellmaw": "Hellmaw'ın Dişleri",
    "staff_of_the_old_root": "Kadim Kök Asası",
    "hollowbell_mace": "Boşçan Topuzu",
    "heartsplitter": "Nightreaper",
    "duskreaver_daggers": "Alacakaranlık Hançerleri",
    "staff_of_the_sundered_sky": "Yarılmış Gök Asası",
    "crownforge_maul": "Taçdemir Gürzü",
    "old_tusks_charm": "Old Tusk'ın Tılsımı",
    "barrow_crown_ring": "Höyük Tacı Yüzüğü",
    "grave_warden_earring": "Mezar Bekçisi Küpesi",
    "mossback_hide_belt": "Mossback Postu Kemer",
    "tyrants_ember": "Tiranın Közü",
    "hellmaw_fang_necklace": "Hellmaw Dişi Kolye",
    "wisp_azure": "Mavi Işık Ruhu",
    "wisp_solar": "Güneş Işık Ruhu",
    "wisp_ember": "Köz Işık Ruhu",
    "wisp_verdant": "Yeşil Işık Ruhu",
    "wisp_violet": "Mor Işık Ruhu",
    "wisp_prism": "Prizma Işık Ruhu",
    "gold_bar": "Altın Külçe",
    "riftstone_green": "Yeşil Yarık Taşı",
    "riftstone_blue": "Mavi Yarık Taşı",
    "riftstone_violet": "Mor Yarık Taşı",
    "wyrmwing_cloak": "Ejderkanat Pelerini",
    "wings_dawnfeather": "Şafaktüyü Kanatları",
    "wings_seraph": "Melek Kanatları",
    "wings_sovereign": "Hükümdar Kanatları",
    "wings_aurelian": "Altın Kanatlar",
    "wings_emberdrake": "Köz Ejderi Kanatları",
    "wings_phoenix": "Anka Kanatları",
    "wings_nightshade": "Gece Gölgesi Kanatları",
    "wings_moonveil": "Ay Tülü Kanatları",
    "wings_frostveil": "Ayaz Tülü Kanatları",
    "clan_cloak_banner": "Klan Sancak Pelerini",
    "clan_cloak_warden": "Klan Muhafız Pelerini",
    "clan_cloak_sovereign": "Klan Hükümdar Pelerini",
    "hp_scroll": "HP Kağıdı +2000",
    "speed_scroll": "Hız Kağıdı +%55",
    "defense_scroll": "Savunma Kağıdı +350",
    "attack_scroll": "Saldırı Kağıdı +100",
    "novice_xp_scroll": "XP Kağıdı +%30",
    "novice_gold_scroll": "Altın Kağıdı +%10",
    "novice_speed_scroll": "Hız Kağıdı +%55",
    "novice_hp_scroll": "HP Kağıdı +300",
    "novice_defense_scroll": "Savunma Kağıdı +30",
    "novice_attack_scroll": "Saldırı Kağıdı +20",
    "bronze_band": "Bronz Yüzük",
    "sage_charm": "Bilge Tılsımı",
    "hunters_earring": "Avcı Küpesi",
    "warders_belt": "Bekçi Kemeri",
    "flameheart_ring": "Alevkalp Yüzüğü",
    "stormglass_earring": "Fırtınacamı Küpe",
    "riftshard_ring": "Yarık Kırığı Yüzük",
    "riftshard_earring": "Yarık Kırığı Küpe",
    "riftbound_earring": "Yarık Bağlı Küpe",
    "riftbound_belt": "Yarık Bağlı Kemer",
    "riftcrown_pendant": "Yarık Tacı Kolyesi",
    "riftwalker_cloak": "Yarık Gezgini Pelerini",
    "hide_hood": "Post Kukuleta",
    "hide_jerkin": "Post Yelek",
    "hide_grips": "Post Eldiven",
    "hide_treads": "Post Çizme",
    "stalker_hood": "İzci Kukuleta",
    "stalker_jerkin": "İzci Yelek",
    "stalker_grips": "İzci Eldiven",
    "stalker_treads": "İzci Çizme",
    "nightveil_hood": "Gecetülü Kukuleta",
    "nightveil_jerkin": "Gecetülü Yelek",
    "nightveil_grips": "Gecetülü Eldiven",
    "nightveil_treads": "Gecetülü Çizme",
    "drakescale_hood": "Ejder Pulu Kukuleta",
    "drakescale_jerkin": "Ejder Pulu Yelek",
    "drakescale_grips": "Ejder Pulu Eldiven",
    "drakescale_treads": "Ejder Pulu Çizme",
    "linen_hat": "Keten Şapka",
    "linen_robe": "Keten Cübbe",
    "linen_wraps": "Keten Sargı",
    "linen_slippers": "Keten Terlik",
    "silkweave_hat": "İpek Dokuma Şapka",
    "silkweave_robe": "İpek Dokuma Cübbe",
    "silkweave_wraps": "İpek Dokuma Sargı",
    "silkweave_slippers": "İpek Dokuma Terlik",
    "moonsilk_hat": "Ay İpeği Şapka",
    "moonsilk_robe": "Ay İpeği Cübbe",
    "moonsilk_wraps": "Ay İpeği Sargı",
    "moonsilk_slippers": "Ay İpeği Terlik",
    "emberweave_hat": "Kor Dokuma Şapka",
    "emberweave_robe": "Kor Dokuma Cübbe",
    "emberweave_wraps": "Kor Dokuma Sargı",
    "emberweave_slippers": "Kor Dokuma Terlik",
    "acolyte_circlet": "Mürit Taç",
    "acolyte_vestment": "Mürit Kaftan",
    "acolyte_gloves": "Mürit Eldiven",
    "acolyte_boots": "Mürit Çizme",
    "cleric_circlet": "Rahip Taç",
    "cleric_vestment": "Rahip Kaftan",
    "cleric_gloves": "Rahip Eldiven",
    "cleric_boots": "Rahip Çizme",
    "sanctified_circlet": "Kutsal Taç",
    "sanctified_vestment": "Kutsal Kaftan",
    "sanctified_gloves": "Kutsal Eldiven",
    "sanctified_boots": "Kutsal Çizme",
    "dawnforged_circlet": "Şafakdöven Taç",
    "dawnforged_vestment": "Şafakdöven Kaftan",
    "dawnforged_gloves": "Şafakdöven Eldiven",
    "dawnforged_boots": "Şafakdöven Çizme",
    "titan_sword": "Titan Kılıcı",
    "titan_greataxe": "Titan Baltası",
    "phantom_daggers": "Hayalet Hançerler",
    "astral_staff": "Yıldız Asası",
    "seraphic_mace": "Melek Topuzu",
    "titan_shield": "Titan Kalkanı",
    "titan_helm": "Titan Miğferi",
    "titan_plate": "Titan Göğüslüğü",
    "titan_gauntlets": "Titan Eldiveni",
    "titan_boots": "Titan Çizmesi",
    "phantom_hood": "Hayalet Kukuleta",
    "phantom_jerkin": "Hayalet Yelek",
    "phantom_grips": "Hayalet Eldiven",
    "phantom_treads": "Hayalet Çizme",
    "astral_hat": "Yıldız Şapka",
    "astral_robe": "Yıldız Cübbe",
    "astral_wraps": "Yıldız Sargı",
    "astral_slippers": "Yıldız Terlik",
    "seraphic_circlet": "Melek Tacı",
    "seraphic_vestment": "Melek Kaftanı",
    "seraphic_gloves": "Melek Eldiveni",
    "seraphic_boots": "Melek Çizmesi",
    "bronze_ring_might": "Bronz Güç Yüzüğü",
    "bronze_ring_swift": "Bronz Çeviklik Yüzüğü",
    "bronze_ring_arcane": "Bronz Büyü Yüzüğü",
    "bronze_ring_ward": "Bronz Koruma Yüzüğü",
    "bronze_neck_might": "Bronz Güç Muskası",
    "bronze_neck_swift": "Bronz Çeviklik Muskası",
    "bronze_neck_arcane": "Bronz Büyü Muskası",
    "bronze_neck_ward": "Bronz Koruma Muskası",
    "bronze_earring_might": "Bronz Güç Küpesi",
    "bronze_earring_swift": "Bronz Çeviklik Küpesi",
    "bronze_earring_arcane": "Bronz Büyü Küpesi",
    "bronze_earring_ward": "Bronz Koruma Küpesi",
    "bronze_belt_might": "Bronz Güç Kemeri",
    "bronze_belt_swift": "Bronz Çeviklik Kemeri",
    "bronze_belt_arcane": "Bronz Büyü Kemeri",
    "bronze_belt_ward": "Bronz Koruma Kemeri",
    "silver_ring_might": "Gümüş Güç Yüzüğü",
    "silver_ring_swift": "Gümüş Çeviklik Yüzüğü",
    "silver_ring_arcane": "Gümüş Büyü Yüzüğü",
    "silver_ring_ward": "Gümüş Koruma Yüzüğü",
    "silver_neck_might": "Gümüş Güç Muskası",
    "silver_neck_swift": "Gümüş Çeviklik Muskası",
    "silver_neck_arcane": "Gümüş Büyü Muskası",
    "silver_neck_ward": "Gümüş Koruma Muskası",
    "silver_earring_might": "Gümüş Güç Küpesi",
    "silver_earring_swift": "Gümüş Çeviklik Küpesi",
    "silver_earring_arcane": "Gümüş Büyü Küpesi",
    "silver_earring_ward": "Gümüş Koruma Küpesi",
    "silver_belt_might": "Gümüş Güç Kemeri",
    "silver_belt_swift": "Gümüş Çeviklik Kemeri",
    "silver_belt_arcane": "Gümüş Büyü Kemeri",
    "silver_belt_ward": "Gümüş Koruma Kemeri",
    "gold_ring_might": "Altın Güç Yüzüğü",
    "gold_ring_swift": "Altın Çeviklik Yüzüğü",
    "gold_ring_arcane": "Altın Büyü Yüzüğü",
    "gold_ring_ward": "Altın Koruma Yüzüğü",
    "gold_neck_might": "Altın Güç Muskası",
    "gold_neck_swift": "Altın Çeviklik Muskası",
    "gold_neck_arcane": "Altın Büyü Muskası",
    "gold_neck_ward": "Altın Koruma Muskası",
    "gold_earring_might": "Altın Güç Küpesi",
    "gold_earring_swift": "Altın Çeviklik Küpesi",
    "gold_earring_arcane": "Altın Büyü Küpesi",
    "gold_earring_ward": "Altın Koruma Küpesi",
    "gold_belt_might": "Altın Güç Kemeri",
    "gold_belt_swift": "Altın Çeviklik Kemeri",
    "gold_belt_arcane": "Altın Büyü Kemeri",
    "gold_belt_ward": "Altın Koruma Kemeri",
    "legion_belt": "Lejyon Kemeri",
    "mantle_lionheart": "Aslanyürek Mantosu",
    "mantle_starweave": "Yıldız Dokuma Pelerin",
    "mantle_emberwake": "Köz İzi Pelerini",
    "mantle_wildheart": "Yabanyürek Mantosu",
    "whitecrown_mantle": "Beyaz Taç Pelerini",
    "race_change_scroll": "Öteki Sancak Kağıdı",
    "gender_change_scroll": "Öteki Ben Kağıdı",
    "sapphire_coffer": "Safir Sandık",
    "jade_coffer": "Yeşim Sandık",
    "greater_sapphire_coffer": "Büyük Safir Sandık",
    "greater_jade_coffer": "Büyük Yeşim Sandık"
  },
  "mobs": {
    "training_dummy": "Antrenman Kuklası",
    "bristle_boar": "Kıllı Yaban Domuzu",
    "ash_wolf": "Kül Kurdu",
    "mire_toad": "Bataklık Kurbağası",
    "stone_husk": "Taş Kabuk",
    "thornback_boar": "Dikensırt Domuz",
    "bandit": "Haydut",
    "alpha_wolf": "Alfa Kurt",
    "mire_lurker": "Bataklık Pusucusu",
    "barrow_skeleton": "Höyük İskeleti",
    "cave_bear": "Mağara Ayısı",
    "forest_troll": "Orman Trolü",
    "granite_golem": "Granit Golem",
    "dire_wolf": "Vahşi Kurt",
    "ogre_brute": "Kaba Ogre",
    "ash_revenant": "Kül Hortlağı",
    "hellhound": "Cehennem Tazısı",
    "obsidian_golem": "Obsidyen Golem",
    "cinder_warden": "Kor Muhafızı",
    "magma_behemoth": "Magma Devi",
    "gloom_stalker": "Kasvet Avcısı",
    "old_tusk": "Old Tusk",
    "barrow_king": "Höyük Kralı",
    "mossback": "Kadim Mossback",
    "cinder_tyrant": "Kor Tiranı",
    "hellmaw": "Hellmaw",
    "grak_warlord": "Savaş Beyi Grak",
    "ancient_colossus": "Kadim Dev",
    "gnarlhide": "Gnarlhide",
    "redmane": "Redmane",
    "grimtusk": "Grimtusk",
    "bonecaller": "Kemik Çağıran",
    "rift_shade": "Umbral Gölgesi",
    "duskbound_sentinel": "Alacakaranlık Nöbetçisi",
    "voidstone_golem": "Boşluktaşı Golem",
    "riftborn_stalker": "Yarıkdoğan Avcı",
    "cinder_wyrm": "Kor Ejderi Skorvyn",
    "ashen_gladiator": "Kül İğnesi",
    "crown_champion": "Taç Şampiyonu",
    "rimefang_wolf": "Kırağıdiş Kurt",
    "rime_golem": "Kırağı Golem",
    "hoarfrost_titan": "Kırağı Titanı",
    "magma_toad": "Magma Kurbağası",
    "slag_brute": "Cüruf Canavarı",
    "pyreheart": "Pyreheart",
    "war_keeper_human": "Valcrest Savaş Bekçisi",
    "war_keeper_orc": "Gorzhak Savaş Bekçisi",
    "event_frostbeard": "Ayaz Sakal Dede",
    "event_gilded_imp": "Yaldızlı İblisçik",
    "clash_crystal": "Çatışma Kristali",
    "greater_clash_crystal": "Büyük Çatışma Kristali"
  },
  "skills": {
    "warrior_cleave": "Ağır Darbe",
    "warrior_shield_bash": "Kalkan Vuruşu",
    "warrior_war_cry": "Savaş Narası",
    "warrior_charge": "Hücum",
    "warrior_iron_skin": "Demir Deri",
    "warrior_sprint": "Koşu",
    "rogue_twin_strike": "İkiz Darbe",
    "rogue_venom_blade": "Zehirli Bıçak",
    "rogue_shadow_step": "Gölge Adımı",
    "rogue_hamstring": "Topuk Kesme",
    "rogue_ambush": "Pusu",
    "rogue_swift": "Çeviklik",
    "mage_firebolt": "Ateş Oku",
    "mage_frost_nova": "Ayaz Isırığı",
    "mage_blink": "Işınlanma",
    "mage_meteor": "Meteor",
    "mage_sprint": "Koşu",
    "priest_smite": "İlahi Darbe",
    "priest_mend": "Onarma",
    "priest_blessing": "Kutsama",
    "priest_sprint": "Koşu",
    "warrior_sunder": "Zırh Parçalama",
    "warrior_execute": "Cellat Darbesi",
    "rogue_crippling_venom": "Sakatlayan Zehir",
    "rogue_blade_flurry": "Bıçak Fırtınası",
    "mage_flame_wave": "Alev Dalgası",
    "mage_cataclysm": "Kıyamet",
    "priest_prayer": "Şifa Duası",
    "priest_judgment": "Hüküm",
    "priest_purify": "Arındırma",
    "rogue_shake_off": "Silkinme",
    "mage_arcane_recall": "Gizemli Dönüş",
    "mage_glacier": "Buzul",
    "priest_plague": "Veba",
    "priest_cure_all": "Tam Arınma",
    "warrior_rose_blade": "Gül Kılıcı",
    "priest_radiant_strike": "Işıltılı Darbe"
  },
  "classes": {
    "warrior": {
      "name": "Savaşçı"
    },
    "rogue": {
      "name": "Suikastçı"
    },
    "mage": {
      "name": "Büyücü"
    },
    "priest": {
      "name": "Rahip"
    }
  },
  "zones": {
    "dev_field": "Hearthmoor",
    "human_homeland": "Valcrest",
    "orc_homeland": "Gorzhak",
    "colony_zone": "Colony Zone",
    "umbral_rift": "Umbral Yarığı",
    "morgard": "Morgard",
    "crystal_clash_1": "Kristal Çatışması",
    "crystal_clash_2": "Kristal Çatışması"
  },
  "npcs": {
    "oswin": {
      "title": "Tüccar",
      "greeting": "Sağlam çelik, kaliteli deri. Buyur bir bak."
    },
    "ilsa": {
      "title": "Katip",
      "greeting": "Her kağıt elle yazılır, altın külçeler de tacın mührüyle basılır. Lekelere aldırma."
    },
    "brann": {
      "title": "Demirci",
      "greeting": "Bana çelik ve kağıt getir. Gerisine örs karar verir."
    },
    "corvin": {
      "title": "Tüccar",
      "greeting": "Taç mühürlü mallar, adil fiyatlar."
    },
    "wendell": {
      "title": "Katip",
      "greeting": "Demirhane için kağıtlar, servet taşıyanlar için altın külçeler."
    },
    "throk": {
      "title": "Tüccar",
      "greeting": "Ödersin, alırsın. Bu kadar basit."
    },
    "vashka": {
      "title": "Katip",
      "greeting": "Kan mürekkebiyle yazılmış kağıtlar, her kılıca yeter. Parası olana altın külçe de var."
    },
    "bren": {
      "title": "Levazımcı",
      "greeting": "Puanlarını sahada mı kazandın? O zaman onlara layık bir pelerin seç."
    },
    "uzga": {
      "title": "Levazımcı",
      "greeting": "Burada kumaşı kan satın alır. Neler kazandığını göster bakalım."
    },
    "garrick": {
      "title": "Depo",
      "greeting": "Bana bırak. Rafımdan hiçbir şey kaybolmaz."
    },
    "ysolde": {
      "title": "Depo",
      "greeting": "Eşyaların burada güvende, tacın kendi kasalarında mühürlü."
    },
    "morga": {
      "title": "Depo",
      "greeting": "Yığına koy. Morga neyin senin olduğunu unutmaz."
    },
    "nessa": {
      "title": "Taş Ustası",
      "greeting": "Umbral Yarığı'ndan Yarık Taşı mı getirdin? Çarkımda kır, bakalım ne çıkacak. Bazen hiçbir şey, bazen bir servet."
    },
    "hollin": {
      "title": "Yarık Tüccarı",
      "greeting": "Buradan kasabaya dönüş uzun. Taşıyamadıklarını ben alırım."
    },
    "grasha": {
      "title": "Yarık Tüccarı",
      "greeting": "Karanlığın ganimeti mi? Buraya koy, paran iyi."
    },
    "edra": {
      "title": "Klan Kahyası",
      "greeting": "Bir klan renklerini savaş meydanında kazanır. Dereceni göster, seni onlarla giydireyim."
    },
    "borgash": {
      "title": "Klan Kahyası",
      "greeting": "Klanın adı için kan mı döktü? O zaman o adı taşıyabilir."
    },
    "maren": {
      "title": "Katip",
      "greeting": "Burada mürekkep çabuk kurur. Kağıdını Gorzhak'tan önce oku."
    },
    "grisha": {
      "title": "Katip",
      "greeting": "Cephe için kağıtlar. Öde, oku, git bir şeyler kır."
    },
    "tolwen": {
      "title": "Katip",
      "greeting": "Savaş için: Bekçi düşene kadar seni ayakta tutacak kağıtlar."
    },
    "hrask": {
      "title": "Katip",
      "greeting": "Bekçi çıplak elle düşmez. Bir kağıt al."
    },
    "sethra": {
      "title": "Yarık Katibi",
      "greeting": "Yarık dikkatsizleri yutar. Dışarı çıkmadan bir kağıt oku."
    },
    "kurzog": {
      "title": "Yarık Katibi",
      "greeting": "Burada gölgeler sert vurur. Gücü sayfa sayfa satın al."
    },
    "aldric": {
      "title": "Şampiyonlar Habercisi",
      "greeting": "Ulusuna önderlik eden her ismi kitabıma yazarım. Seninki birinciyse, tacın ödülü seni bekliyor."
    },
    "ko_moradon_herald": {
      "title": "Şampiyonlar Habercisi",
      "greeting": "Ulusuna önderlik eden her ismi kitabıma yazarım. Seninki birinciyse, tacın ödülü seni bekliyor."
    }
  },
  "quests": {
    "boar_cull": {
      "name": "Şalgam Tarlasında Dişler",
      "text": "Kıllı yaban domuzları köyün etrafındaki bütün tarlaları eşeliyor. Sayılarını azalt."
    },
    "grey_pelts": {
      "name": "Gri Postlar",
      "text": "Tabakçı soğuklar başlamadan kül kurdu postu istiyor."
    },
    "mire_toads": {
      "name": "Bataklıkta Vıraklama",
      "text": "Bataklık kurbağaları bataklıktan yola taşmış. Onları geri püskürt."
    },
    "husk_hearts": {
      "name": "Taştan Kalpler",
      "text": "Taş kabukların içinde sıcak bir taş var. İncelemek için birkaç tane getir."
    },
    "thornbacks": {
      "name": "Dikensırt Belası",
      "text": "Dikensırt domuzlar iki tarla işçisini boynuzladı. Bu işe bir son ver."
    },
    "road_tax": {
      "name": "Yol Vergisi",
      "text": "Haydutlar yoldaki her arabayı soyuyor. Çaldıklarını geri al."
    },
    "pack_leaders": {
      "name": "Sürü Liderleri",
      "text": "Alfaları olmadan kurt sürüleri dağılır."
    },
    "lurker_eyes": {
      "name": "Sudaki Gözler",
      "text": "Bataklık pusucularının gözleri karanlıkta parlar. Simyacı bunlara para veriyor."
    },
    "barrow_rest": {
      "name": "Höyüklere Huzur",
      "text": "Ölüler geceleri eski höyüklerden çıkıyor. Onları yeniden uykuya gönder."
    },
    "bear_country": {
      "name": "Ayı Diyarı",
      "text": "Mağara ayıları çiftliklere inmiş. Kış gelmeden onları avla."
    },
    "bear_claws": {
      "name": "Tabakçıya Pençe",
      "text": "Mağara ayısı pençelerinden en iyi kancalar ve tılsımlar yapılır."
    },
    "troll_hunt": {
      "name": "Trol Avı",
      "text": "Orman trolleri oduncu kamplarını yağmalıyor."
    },
    "troll_hides": {
      "name": "Yosunlu Postlar",
      "text": "Trol postu kılıcı durdurur. Zırhçılar bulabildikleri her şeyi istiyor."
    },
    "stone_giants": {
      "name": "Taş Devler",
      "text": "Granit golemler taş ocağı yolunu kapatıyor. Onları parçala."
    },
    "golem_cores": {
      "name": "Canlı Kaya",
      "text": "Golemleri bir şey hareket ettiriyor. Çekirdeklerinin kırıklarını getir."
    },
    "dire_nights": {
      "name": "Vahşi Geceler",
      "text": "Vahşi kurtlar karanlık çökünce yollarda avlanıyor. Önce sen onları avla."
    },
    "dire_pelts": {
      "name": "Vahşi Postlar",
      "text": "Bir vahşi kurt postu nöbetçiyi bütün gece sıcak tutar."
    },
    "ogre_menace": {
      "name": "Ogre Tehdidi",
      "text": "Kaba ogreler diyarın kenarında toplanıyor. Onları dağıt."
    },
    "ogre_totems": {
      "name": "Savaş Totemleri",
      "text": "Her ogre çetesi bir savaş totemi taşır. Totemleri al, çeteler cesaretini yitirsin."
    },
    "ashes": {
      "name": "Külden Küle",
      "text": "Kül hortlakları Koloni'nin yanık topraklarından yükseliyor. Onları yere ser."
    },
    "grave_embers": {
      "name": "Mezar Közleri",
      "text": "Bir hortlağın içindeki közler hâlâ yanıyor. Birkaçını sağlam getir."
    },
    "pit_hounds": {
      "name": "Çukurun Tazıları",
      "text": "Cehennem tazıları Koloni'de sürü halinde dolaşıyor. Sürüleri seyrelt."
    },
    "brimstone_fangs": {
      "name": "Kükürt Dişler",
      "text": "Cehennem tazısı dişleri dokununca yakar. Demirciler ocak için istiyor."
    },
    "black_glass": {
      "name": "Kara Cam",
      "text": "Obsidyen golemler cam tarlalarını koruyor. Aralarından yol aç."
    },
    "obsidian_shards": {
      "name": "Obsidyen Kırıkları",
      "text": "Keskin obsidyenden iyi ok ucu olur. Kırılmamış parçalar getir."
    },
    "cinder_wardens": {
      "name": "Kor Muhafızları",
      "text": "Kor muhafızları yanan harabelerde nöbet tutuyor. Onları biç."
    },
    "warden_sigils": {
      "name": "Muhafız Mühürleri",
      "text": "Her muhafız eski ateşin mührünü taşır. Onları al."
    },
    "molten_giants": {
      "name": "Erimiş Devler",
      "text": "Magma devleri lav tarlalarından sürünerek çıkıyor. Onları durdur."
    },
    "gloom_eyes": {
      "name": "Kasvetteki Avcılar",
      "text": "Kasvet avcıları karanlıkta görür. Gözleri bir servet eder."
    },
    "nation_war": {
      "name": "Taç İçin Kan",
      "text": "Colony Zone'da karşı ulustan 100 savaşçıyı yen. Partindeki herkesin öldürdükleri herkese sayılır."
    },
    "ko_worm_extermination": {
      "name": "Worm Avı",
      "text": "Moradon'un tüccarları hızla çoğalan Worm'lardan bıktı. Isaac'e onlardan 10 Silk Bundle getir."
    },
    "ko_proconsul_request": {
      "name": "Prokonsülün Ricası",
      "text": "Moradon Prokonsülü 5 Silk Bundle karşılığında yardım edecek. Surların dışındaki Earth Worm'larda bulunur."
    },
    "ko_gavolt_extermination": {
      "name": "Gavolt Avı",
      "text": "Gavolt'lar iki ulusun ana köylerinin çevresinde çoğalıyor. Isaac'e 5 Gavolt Wing sözü verdin."
    },
    "ko_bulture_horns": {
      "name": "Bulture Boynuzu Toplama",
      "text": "Demirciler yay yapmak için Bulture Horn kullanıyor. Isaac'e 5 tane sözü verdin."
    },
    "ko_guard_trainee": {
      "name": "Moradon'daki Muhafız Adayı",
      "text": "Moradon'daki muhafız adayı 3 Bulture Horn istiyor."
    },
    "ko_wolfman_extermination": {
      "name": "Kurt Adam Avı",
      "text": "Her dolunayda inen kurt adamlar tüccarları rahatsız ediyor. Sayılarını azalt."
    },
    "ko_fang_of_wolf_man": {
      "name": "Kurt Adam Dişi",
      "text": "Muhafız Patrick getirdiğin her 5 Fang of Wolf Man için ödeme yapar. Bunu istediğin kadar tekrarlayabilirsin (burada günde bir kez)."
    },
    "ko_recon_report": {
      "name": "Keşif Raporu",
      "text": "Düşman casusları ulusumuza sızdı ve keşif erimizi kuşattı. Onları temizle ve erimizle buluş."
    },
    "ko_recon_report_2": {
      "name": "Keşif Raporu",
      "text": "Düşman casusları ulusumuza sızdı ve keşif erimizi kuşattı. Onları temizle ve erimizle buluş."
    },
    "ko_zombie_eyes": {
      "name": "Zombi Gözleri",
      "text": "Başbüyücü Drake çalışmaları için Zombie Eye istiyor. Ona 10 tane getir."
    },
    "ko_cursed_bones": {
      "name": "Lanetli Kemikler",
      "text": "Sınıf ustaları Skeleton Warrior'lardan Cursed Bone istiyor. 10 tane getir."
    },
    "ko_blood_of_glyptodont": {
      "name": "Glyptodont Kanı",
      "text": "Gizli Ajan Clarence ovaların büyük hayvanlarından 10 Blood of Glyptodont istiyor."
    },
    "ko_blood_of_glyptodont_2": {
      "name": "Glyptodont Kanı",
      "text": "Gizli Ajan Clarence ovaların büyük hayvanlarından 10 Blood of Glyptodont istiyor."
    },
    "ko_asga_fruit": {
      "name": "Asga Meyvesi",
      "text": "Cardinal'ların çaldığı 5 Asga Fruit'i Asga Köyü'ndeki Gizli Ajan Clarence'a geri götür."
    },
    "ko_bell_of_bellua": {
      "name": "Bellua'nın Çanı",
      "text": "Cardinal'ların çaldığı 5 Asga Fruit'i Bellua Köyü'ndeki Gizli Ajan Clarence'a geri götür."
    },
    "ko_tyon_meat": {
      "name": "Tyon Eti",
      "text": "Kraliyet Aşçısı Tyon Meat istiyor. Tyon avla ve 5 tane getir."
    },
    "ko_gem_of_bravery": {
      "name": "Cesaret Taşı",
      "text": "Bloodon'larla savaşarak 10 Gem of Bravery topla. Kendini kanıtla!"
    },
    "ko_invasion": {
      "name": "İstila",
      "text": "Vadilerde Lich'ler uyandı. Köylere ulaşmadan onları avla."
    },
    "ko_invasion_2": {
      "name": "İstila",
      "text": "Vadilerde Lich'ler uyandı. Köylere ulaşmadan onları avla."
    },
    "ko_grell_tentacles": {
      "name": "Dokunaçlar",
      "text": "Gizli Ajan Clarence Grell'lerden Tentacle istiyor, günlük bir iş."
    },
    "ko_orc_bandit_bracelets": {
      "name": "Ork Haydutlarının Bilezikleri",
      "text": "Savaşçı Ustası Skaky, Ronark Land'de dolaşan Ork Haydutlarının bileziklerini istiyor. Günde 10 tane getir."
    },
    "ko_bandicoot_trouble": {
      "name": "Bandicoot Belası",
      "text": "Wild Bandicoot'lar her gece Moradon'un çitlerinin altını kazıyor. Ambarlara varmadan 12 tanesini kov."
    },
    "ko_crawler_shells": {
      "name": "Crawler Kabukları",
      "text": "Zırhçı, çıraklarının kalkanlarını kaplamak için sert kabuk istiyor. Carrion Crawler'lardan ona 6 tane getir."
    },
    "ko_kecoon_scouts": {
      "name": "Kecoon Gözcüleri",
      "text": "Kecoon Scout'lar Moradon'a giden yolları gözlüyor. Savaş grupları nöbet saatlerini öğrenmeden 12 tanesini indir."
    },
    "ko_rabid_pack": {
      "name": "Kuduz Sürü",
      "text": "Kuduz bir sürü yoldan sapan herkesi ısırıyor. 10 tanesini öldür."
    },
    "ko_kecoon_banners": {
      "name": "Kecoon Sancakları",
      "text": "Kecoon Fighter'ların sancaklarını al: onlarsız baskınlarının şevki kırılır. 6 tane geri getir."
    },
    "ko_bulcan_hides": {
      "name": "Bulcan Postları",
      "text": "Tabakçı kış öncesi kalın postlara iyi para veriyor. Wild Bulcan'lardan 6 tane getir."
    },
    "ko_smilodon_hunt": {
      "name": "Smilodon Avı",
      "text": "Smilodon'lar kalenin dışındaki sürülerin peşinde. Sayılarını 20 azalt."
    },
    "ko_savage_totems": {
      "name": "Savage Totemleri",
      "text": "Savage'lar soydaşlarını çağırmak için totem dikiyor. Kamplarını dağıt ve 8 totem geri getir."
    },
    "ko_keilan_claws": {
      "name": "Keilan Pençeleri",
      "text": "Bir demirci kılıçlarına su vermek için Keilan pençesi istiyor. Ona 8 tane getir."
    },
    "ko_keilan_claws_2": {
      "name": "Keilan Pençeleri",
      "text": "Bir demirci kılıçlarına su vermek için Keilan pençesi istiyor. Ona 8 tane getir."
    },
    "ko_sabertooth_fangs": {
      "name": "Sabertooth Dişleri",
      "text": "Kale muhafız komutanı bir avcının değerinin kanıtı olarak Sabertooth dişi topluyor. 8 tane getir."
    },
    "ko_ape_troop": {
      "name": "Ape Sürüsü",
      "text": "Bir Ape sürüsü yolun kenarındaki tepeleri ele geçirdi. 25 tanesini temizle."
    },
    "ko_machirodus_pelts": {
      "name": "Machirodus Postları",
      "text": "Kalenin nöbetçileri için sıcak postlar: Machirodus'lardan 10 tane getir."
    },
    "ko_death_knights": {
      "name": "Death Knight'lar",
      "text": "Death Knight'lar eski savaş alanlarından kalkıyor. 20 tanesini toprağa geri gönder."
    },
    "ko_hornet_stingers": {
      "name": "Hornet İğneleri",
      "text": "Şifacılar Hornet iğnelerinden merhem yapıyor. Onlara 10 tane getir."
    },
    "ko_goblin_bouncers": {
      "name": "Goblin Bouncer'lar",
      "text": "Goblin Bouncer'lar doğu yolundaki her kervanı soyuyor. 15 tanesini yen."
    },
    "ko_sheriff_badges": {
      "name": "Sheriff Rozetleri",
      "text": "Sheriff'ler toprakları kendilerininmiş gibi sahipleniyor. Öyle olmadığını kanıtlamak için 8 rozetlerini geri getir."
    },
    "ko_cz_daily_war": {
      "name": "Colony'yi Tut",
      "text": "Öteki ulus tarlalarımızda kendi toprağıymış gibi dolaşıyor. Bugün Colony Zone'da onlardan 100 kişiyi indir; partinin öldürdükleri de sana sayılır."
    },
    "ko_sheriff_badges_2": {
      "name": "Sheriff Rozetleri",
      "text": "Sheriff'ler toprakları kendilerininmiş gibi sahipleniyor. Öyle olmadığını kanıtlamak için 8 rozetlerini geri getir."
    },
    "ko_guide_4": {
      "name": "Bandicoot Avı",
      "text": "[Moradon Nöbetçisi] Hesta benden 5 Bandicoot avlamamı istedi."
    },
    "ko_guide_82": {
      "name": "Shadow Seeker Avı",
      "text": "[Kahin] Felian sana 15 Shadow Seeker avlama görevi verdi."
    },
    "ko_guide_693": {
      "name": "Güvenli Göç Yolu",
      "text": "Moradon'a doğru giden Fortu'ların yolunu temizle."
    },
    "ko_guide_722": {
      "name": "Ormanın Derinliklerine",
      "text": "20 Ancient'ı yen."
    },
    "ko_guide_736": {
      "name": "Zaman Daralıyor",
      "text": "Kalkan düştüğüne göre ork kalesine git ve hepsini yok et."
    },
    "ko_guide_739": {
      "name": "Öfkeli Canavarlar 1",
      "text": "Ruh taşının bozduğu Cardinal'ları yen."
    },
    "ko_guide_741": {
      "name": "Öfkeli Canavarlar 3",
      "text": "Ruh taşının bozduğu Baron'ları yen."
    },
    "ko_guide_888": {
      "name": "Glyptodont Avı",
      "text": "[Beyaz Gölge Kaptanı] Osiris benden 5 Glyptodont avlamamı istedi."
    },
    "ko_guide_889": {
      "name": "Gloomwing Avı",
      "text": "[Denizci] Hein benden 10 Gloomwing avlamamı istedi."
    }
  },
  "store": {
    "wings_dawn": "Şafaktüyü Kanatları",
    "wings_seraph": "Melek Kanatları",
    "wings_sovereign": "Hükümdar Kanatları",
    "wings_aurelian": "Altın Kanatlar",
    "wings_ember": "Köz Ejderi Kanatları",
    "wings_phoenix": "Anka Kanatları",
    "wings_nightshade": "Gece Gölgesi Kanatları",
    "wings_moon": "Ay Tülü Kanatları",
    "wings_frost": "Ayaz Tülü Kanatları",
    "skin_crimson": "Kızıl Şövalye",
    "skin_frost": "Ayaz Muhafızı",
    "skin_gilded": "Yaldızlı Hükümdar",
    "skin_shadow": "Gölge Avcısı",
    "skin_storm": "Fırtına Çağıran",
    "glow_azure": "Mavi Işık Ruhu",
    "glow_solar": "Güneş Işık Ruhu",
    "glow_ember": "Köz Işık Ruhu",
    "glow_verdant": "Yeşil Işık Ruhu",
    "glow_violet": "Mor Işık Ruhu",
    "glow_prism": "Prizma Işık Ruhu",
    "fortune_stone_1": "Şans Taşı",
    "fortune_stone_10": "Şans Taşı x10",
    "premium_30": "Gold Premium, 30 gün",
    "market_scroll_30": "Pazar Kağıdı, 30 gün",
    "cloak_lionheart": "Aslanyürek Mantosu",
    "cloak_starweave": "Yıldız Dokuma Pelerin",
    "cloak_emberwake": "Köz İzi Pelerini",
    "cloak_wildheart": "Yabanyürek Mantosu"
  },
  "structures": {},
  "pvpRanks": {
    "Skirmisher": "Akıncı",
    "Blooded": "Kan Görmüş",
    "Veteran": "Kıdemli",
    "Champion": "Şampiyon",
    "Paragon": "Efsane",
    "Sovereign": "Hükümdar",
    "Exalted": "Yüce",
    "Vanguard": "Öncü",
    "Warden": "Muhafız",
    "Sentinel": "Nöbetçi",
    "Outrider": "Gözcü"
  },
  "wheelLabels": {
    "Mithril armor": "Mithril zırh",
    "Mithril weapon": "Mithril silah",
    "Dragon armor": "Ejder zırh",
    "Dragon weapon": "Ejder silah",
    "Unique jewel": "Eşsiz takı",
    "Unique weapon": "Eşsiz silah",
    "Legendary weapon": "Efsanevi silah",
    "Riftshard jewel": "Yarık Kırığı takısı",
    "Riftbound jewel": "Yarık Bağı takısı",
    "Rift regalia": "Yarık nişanları",
    "Level 55 weapon": "55. seviye silah",
    "Level 55 armor": "55. seviye zırh",
    "Steel armor": "Çelik zırh",
    "Steel weapon": "Çelik silah",
    "Silver jewel": "Gümüş takı",
    "Gold jewel": "Altın takı"
  },
  "koNpcText": {
    "Accessory": "Aksesuar",
    "Advisor": "Danışman",
    "Analyst": "Analist",
    "Archmage": "Başbüyücü",
    "Armor": "Zırh",
    "Armor Merchant": "Zırh Tüccarı",
    "Arms": "Silah",
    "Ascetic": "Münzevi",
    "Cape Merchant": "Pelerin Tüccarı",
    "Captain": "Kaptan",
    "Clans": "Klanlar",
    "Election Officer": "Seçim Görevlisi",
    "Exchange": "Takas",
    "Farm Manager": "Çiftlik Kahyası",
    "Fled Slave": "Kaçak Köle",
    "Goblin Punitive Force": "Goblin Cezalandırma Birliği",
    "Grand Chamberlain": "Başmabeyinci",
    "Great Priest": "Başrahip",
    "Guard of the Key": "Anahtar Muhafızı",
    "Hunter": "Avcı",
    "Imperial Palace Chef": "Saray Aşçısı",
    "Imperial Palace Guard": "Saray Muhafızı",
    "Importer": "İthalatçı",
    "Inn": "Han",
    "Inn Hostess": "Han Sahibesi",
    "Item Appraiser": "Eşya Eksperi",
    "Keeper of the Key": "Anahtar Bekçisi",
    "Knight Clerk": "Şövalye Katibi",
    "Lunar Gate Guard": "Ay Kapısı Muhafızı",
    "Manager": "Yönetici",
    "Mercenary": "Paralı Asker",
    "Moradon Merchant": "Moradon Tüccarı",
    "Moradon Watch": "Moradon Nöbetçisi",
    "Oracle": "Kahin",
    "Outpost Captain": "Karakol Kaptanı",
    "Patroller of the Key": "Anahtar Devriyesi",
    "Potion Merchant": "İksir Tüccarı",
    "Priest": "Rahip",
    "Protector of the Key": "Anahtar Koruyucusu",
    "Punitive Force Staff": "Cezalandırma Birliği Subayı",
    "Ranger of the Key": "Anahtar İzcisi",
    "Reserve Knight Captain": "Yedek Şövalye Kaptanı",
    "Sailor": "Denizci",
    "Scout": "Keşifçi",
    "Searcher of the Key": "Anahtar Arayıcısı",
    "Sundries": "Çeşitli Eşya",
    "Tactician": "Taktisyen",
    "Tomb Gatekeeper": "Mezar Kapıcısı",
    "Upgrade": "Geliştirme",
    "Upgrade Scrolls": "Geliştirme Parşömenleri",
    "Watcher of the Key": "Anahtar Gözcüsü",
    "Weapon Merchant": "Silah Tüccarı",
    "Blood-ink scrolls, strong enough for any blade. Gold bars too, if you can pay.": "Kan mürekkebiyle yazılmış parşömenler, her kılıca yeter. Paran varsa altın külçeler de var.",
    "Bring me steel and scrolls. The anvil decides the rest.": "Bana çelik ve parşömen getir. Gerisine örs karar verir.",
    "Business is slow. The caravans fear the roads.": "İşler durgun. Kervanlar yollardan korkuyor.",
    "Coin or glory, it is all the same out there. What will it be?": "Para ya da şan, dışarıda hepsi aynı. Hangisi olsun?",
    "Crown-stamped goods, fair prices.": "Tacın mührünü taşıyan mallar, dürüst fiyatlar.",
    "Every scroll is inked by hand, and the gold bars are stamped by the crown. Mind the smudges.": "Her parşömen elle yazılır, altın külçeler de tacın mührüyle basılır. Lekelere aldırma.",
    "Gems and fragments go in, treasure comes out.": "Mücevherler ve parçalar girer, hazine çıkar.",
    "Honest steel and good leather. Take a look.": "Sağlam çelik, kaliteli deri. Buyur bir bak.",
    "Hungry? The king eats first, the guards next, you last.": "Aç mısın? Önce kral yer, sonra muhafızlar, en son sen.",
    "I know every trail out there, and what waits on them.": "Dışarıdaki her patikayı, üstlerinde neyin beklediğini bilirim.",
    "Knowledge is a weapon too. Use it well.": "Bilgi de bir silahtır. İyi kullan.",
    "Leave it with me. Nothing goes missing from my shelves.": "Bana bırak. Raflarımdan hiçbir şey kaybolmaz.",
    "May the light keep your blade sharp and your wounds few.": "Işık kılıcını keskin, yaralarını az tutsun.",
    "Moradon's fences need guarding and its fields need clearing. Lend a hand?": "Moradon'un çitleri korunmalı, tarlaları temizlenmeli. Bir el atar mısın?",
    "No one buys my potions now: the gods give them freely. Go well.": "Artık kimse iksirlerimi almıyor: tanrılar onları bedava veriyor. Yolun açık olsun.",
    "Please, keep your voice down. They may still be looking for me.": "Lütfen sesini alçalt. Hâlâ beni arıyor olabilirler.",
    "Put it in the pile. Morga remembers what is yours.": "Yığına koy. Morga neyin senin olduğunu unutmaz.",
    "Safe roads, traveler.": "Yolun açık olsun, yolcu.",
    "Scrolls for the anvil. Upgrade with care.": "Örs için parşömenler. Dikkatli geliştir.",
    "Scrolls for the forge, and gold bars for those who carry a fortune.": "Demirhane için parşömenler, servet taşıyanlar için de altın külçeler.",
    "Silence teaches what the sword cannot.": "Sessizlik, kılıcın öğretemediğini öğretir.",
    "Stand clear. I keep this gate by the king's order.": "Çekil. Bu kapıyı kralın emriyle bekliyorum.",
    "The beasts trample my fields again. I could use a hand.": "Hayvanlar yine tarlalarımı çiğniyor. Bir yardım iyi olurdu.",
    "The border needs strong arms. Are you here to help?": "Sınırın güçlü kollara ihtiyacı var. Yardıma mı geldin?",
    "The key is kept, and so is the gate. Move along, traveler.": "Anahtar korunuyor, kapı da öyle. Yoluna devam et, yolcu.",
    "The realm runs on order. State your business.": "Krallık düzenle yürür. Derdini söyle.",
    "The sea brought me here and the war keeps me. Ask, if you must.": "Beni buraya deniz getirdi, savaş da tutuyor. Sorman gerekiyorsa sor.",
    "You pay, you take. Simple.": "Ödersin, alırsın. Bu kadar basit.",
    "Your things are safe here, sealed in the crown's own vaults.": "Eşyaların burada güvende, tacın kendi kasalarında mühürlü.",
    "Inn hostess": "Han sahibesi",
    "Anvil": "Örs",
    "Chaotic Generator": "Chaotic Generator",
    "Trader": "Tüccar",
    "Bring me the treasure chests you win in battle. I open them for you.": "Savaşta kazandığın hazine sandıklarını bana getir. Senin için açarım.",
    "Manages the hideout of the 1st class clan.": "Birinci sınıf klanın sığınağını yönetir.",
    "Upon enemy infiltration, when El Morad has taken control of Raon Camp, El Morad can use the gate": "Düşman sızdığında, Raon Kampı El Morad'ın elindeyse El Morad bu kapıyı kullanabilir.",
    "Spies from opponent countries.": "Düşman ülkelerden gelen casuslar.",
    "Captain of the Luferson Castle Guard Squad with singular national loyalty": "Ulusuna eşsiz bir bağlılıkla bağlı Luferson Kalesi Muhafız Birliği'nin kaptanı.",
    "Handles stipends and promotions": "Maaşları ve terfileri yürütür.",
    "Your day should begin and end at our inn don't you think?": "Günün bizim handa başlayıp bizim handa bitmeli, değil mi?",
    "Armor will protect you against your enemies.": "Zırh seni düşmanlarına karşı korur.",
    "The only thing that will protect you is the weapon you have in your hand right now.": "Seni koruyacak tek şey şu an elindeki silah.",
    "A sundries merchant in the El Morad Castle. Sells various miscellaneous goods.": "El Morad Kalesi'nde bir çerçi. Türlü türlü mal satar.",
    "These tools are the beginning of a strategic victory.": "Stratejik bir zafer bu aletlerle başlar.",
    "Commander-in-chief of the El Morad warrior class knight squad; commands and governs everything having to do with the warrior class": "El Morad savaşçı şövalye birliğinin başkomutanı. Savaşçılarla ilgili her şeyi o yönetir.",
    "The head of the rogue class of El Morad who governs all of its activities": "El Morad'ın haydutlarının başı, bütün işlerini o yürütür.",
    "Preeminent mage of the continent conferred the title of Archmage": "Kıtanın en seçkin büyücüsü, Başbüyücü unvanını taşır.",
    "High priest of the Temple of Light of El Morad who is the emotional mentor of the priests of El Morad": "El Morad Işık Tapınağı'nın baş rahibi, El Morad rahiplerinin manevi rehberi.",
    "Jack-of-all-trades who takes care of everything for the Imperial Palace": "İmparatorluk Sarayı'nın her işine koşan, elinden her iş gelen biri.",
    "Assigns Lunar-related spy activities": "Lunar ile ilgili casusluk görevlerini dağıtır.",
    "Guards Lunar Gate and consistently reports the status of Lunar Valley to homeland": "Lunar Kapısı'nı korur ve Lunar Vadisi'nin durumunu yurduna düzenli olarak bildirir.",
    "A woman who perpetually waits for her lover, a Lunar Gate sentinel, at the entrance to Islante": "Islante'nin girişinde, Lunar Kapısı nöbetçisi olan sevgilisini hep bekleyen bir kadın.",
    "Manager of the farm which supplies food to the Army": "Orduya yiyecek sağlayan çiftliğin yöneticisi.",
    "Hunts monsters in Raon Camp vicinity": "Raon Kampı'nın çevresinde canavar avlar.",
    "A newly appointed official who defends the training stone which protects the country's forces.": "Ülkenin ordusunu koruyan eğitim taşını savunan, yeni atanmış bir görevli.",
    "Leader of the resident merchant associations in Moradon and Luperson castles.": "Moradon ve Luperson kalelerindeki tüccar loncalarının başı.",
    "Manages the tomb in Karus's main land.": "Karus'un ana topraklarındaki mezarı yönetir.",
    "Guardian of the first key": "Birinci anahtarın bekçisi.",
    "Guardian of the second key": "İkinci anahtarın bekçisi.",
    "Guardian of the third key": "Üçüncü anahtarın bekçisi.",
    "Guardian of the fifth key": "Beşinci anahtarın bekçisi.",
    "Guardian of the sixth key": "Altıncı anahtarın bekçisi.",
    "Guardian of the seventh key": "Yedinci anahtarın bekçisi.",
    "The slave who took the Dragon's golden goblet.": "Ejderhanın altın kadehini alan köle.",
    "Provides mission related quests": "Göreve dair işler verir.",
    "Upon enemy infiltration, when Karus has taken control of Raon Camp, Karus can use the gate": "Düşman sızdığında, Raon Kampı Karus'un elindeyse Karus bu kapıyı kullanabilir.",
    "Captain of the El Morad Guard Squad with singular national loyalty": "Ulusuna eşsiz bir bağlılıkla bağlı El Morad Muhafız Birliği'nin kaptanı.",
    "Royal chef who makes innovative dishes and is kind to the people": "Yenilikçi yemekler yapan, halka iyi davranan saray aşçısı.",
    "Hunts monsters in Doda Camp vicinity": "Doda Kampı'nın çevresinde canavar avlar.",
    "Leads one of the merchant groups based in Moradon and Luperson castles.": "Moradon ve Luperson kalelerindeki tüccar topluluklarından birinin başı.",
    "Manages the tomb in El Morad's main land.": "El Morad'ın ana topraklarındaki mezarı yönetir.",
    "Do you desire a powerful weapon? It has to be tempered. And even though it costs a bundle there's no guarantees.": "Güçlü bir silah mı istiyorsun? Önce dövülmesi gerekir. Bir servete mal olur, yine de garantisi yoktur.",
    "Every name that leads its nation is written in my book. If yours is first, the crown's reward is waiting.": "Ulusuna önderlik eden her isim benim defterimde yazılı. Seninki ilkse tacın ödülü seni bekliyor.",
    "Responsible for security of Ronark Land": "Ronark Land'in güvenliğinden sorumludur.",
    "Responsible for security of Ardream": "Ardream'in güvenliğinden sorumludur.",
    "Collects information from spies in Ronark Land.": "Ronark Land'deki casuslardan haber toplar.",
    "Ascetic of Islante": "Islante'nin münzevisi.",
    "The Prospective Knight Squad captain who guards the entrance to the underground regions of the Jurad Mountains in Islante.": "Islante'deki Jurad Dağları'nın yeraltı bölgelerinin girişini koruyan Aday Şövalye Birliği kaptanı.",
    "White Shadow Captain": "Beyaz Gölge Kaptanı",
    "Luferson Monument": "Luferson Anıtı",
    "Linate Village Monument": "Linate Köyü Anıtı",
    "Bellua Village monument": "Bellua Köyü Anıtı",
    "Raon Camp Monument": "Raon Kampı Anıtı",
    "Raon Camp Gate": "Raon Kampı Kapısı",
    "Warrior Master": "Savaşçı Ustası",
    "Secret Agent": "Gizli Ajan",
    "Eslant Woman": "Eslantlı Kadın",
    "Karus Refugee": "Karus Mültecisi",
    "Contaminated Karus Refugee": "Hastalıklı Karus Mültecisi",
    "Spirit of Logos": "Logos'un Ruhu",
    "El Morad Monument": "El Morad Anıtı",
    "Asga Village Monument": "Asga Köyü Anıtı",
    "Laiva Village Monument": "Laiva Köyü Anıtı",
    "Doda Camp Monument": "Doda Kampı Anıtı",
    "Doda Camp Gate": "Doda Kampı Kapısı",
    "Bifrost Monument": "Bifrost Anıtı",
    "Bifrost Gate": "Bifrost Kapısı",
    "White Shadow": "Beyaz Gölge",
    "Order of the Sorcery Leader": "Büyü Tarikatı Lideri",
    "The community notice board in Linnart Village. Items posted on this board detail upcoming events or missions available both within Linnart Village and all over Karus, the country to which it belongs.": "Linnart Köyü'nün ilan panosu. Buraya asılanlar hem Linnart Köyü'nde hem de köyün bağlı olduğu Karus'un dört bir yanındaki yaklaşan olayları ve görevleri anlatır.",
    "The community notice board in Laiva Village. Items posted on this board detail upcoming events or missions available both within Laiva Village and all over El Morad, the country to which it belongs.": "Laiva Köyü'nün ilan panosu. Buraya asılanlar hem Laiva Köyü'nde hem de köyün bağlı olduğu El Morad'ın dört bir yanındaki yaklaşan olayları ve görevleri anlatır.",
    "Contains important Classified Documents of El Morad. There are three classes in the Classified Documents.": "El Morad'ın önemli Gizli Belgelerini saklar. Gizli Belgeler üç sınıftır.",
    "Contains important Classified Documents of Karus. There are three classes in the Classified Documents.": "Karus'un önemli Gizli Belgelerini saklar. Gizli Belgeler üç sınıftır.",
    "The remains of the hero who fought bravely and passed away in battle": "Savaşta yiğitçe dövüşüp hayatını kaybeden kahramanın kalıntıları",
    "Karus Bulletin Board": "Karus İlan Panosu",
    "Linate Village Bulletin Board": "Linate Köyü İlan Panosu",
    "Laiva Village Bulletin Board": "Laiva Köyü İlan Panosu",
    "El Morad Bulletin Board": "El Morad İlan Panosu",
    "Karus Secret Archive": "Karus Gizli Arşivi",
    "El Morad Secret Archive": "El Morad Gizli Arşivi",
    "Contaminated El Morad Refugee": "Kirlenmiş El Morad Mültecisi",
    "Reserve Knight": "Yedek Şövalye",
    "Contaminated Warrior": "Kirlenmiş Savaşçı",
    "Corpse of Brave Warrior": "Yiğit Savaşçının Cesedi",
    "Ashes of the Hero": "Kahramanın Külleri",
    "Ronarkland Information Archive": "Ronarkland Bilgi Arşivi"
  }
}
